"use client";
import { useState } from "react";
import { trackFormSubmission, trackServiceInterest } from "@/lib/analytics";

export default function ContactForm(){
  const [form, setForm] = useState({
    name: "",
    email: "",
    need: "positioning",
    message: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  async function onSubmit(e: React.FormEvent){
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const response = await fetch('https://formspree.io/f/manpoakb', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          need: labelFor(form.need),
          message: form.message,
          _subject: `[Portfolio] ${form.name} — ${labelFor(form.need)}`
        })
      });

      if (response.ok) {
        setSubmitStatus('success');
        setForm({ name: "", email: "", need: "positioning", message: "" });
        
        // Track successful form submission
        trackFormSubmission('contact_form', form.need);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  }

  function labelFor(key: string){
    switch (key){
      case "pr": return "PR & Communications";
      case "content-and-seo": return "Content & SEO";
      case "digital-marketing": return "Digital Marketing";
      default: return "Other";
    }
  }

  return (
    <form onSubmit={onSubmit} className="card p-6 rounded-2xl mt-6 grid gap-4">
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="text-sm">Name</label>
          <input
            required
            value={form.name}
            onChange={e=>setForm({...form, name:e.target.value})}
            className="mt-1 w-full border rounded-lg px-3 py-2 bg-white"
            placeholder="Your name"
          />
        </div>
        <div>
          <label className="text-sm">Email</label>
          <input
            required
            type="email"
            value={form.email}
            onChange={e=>setForm({...form, email:e.target.value})}
            className="mt-1 w-full border rounded-lg px-3 py-2 bg-white"
            placeholder="you@company.com"
          />
        </div>
      </div>

      <div>
        <label className="text-sm">What you need help with</label>
        <select
          value={form.need}
          onChange={e => {
            setForm({...form, need:e.target.value});
            // Track service interest
            trackServiceInterest(e.target.value, 'contact_form');
          }}
          className="mt-1 w-full border rounded-lg px-3 py-2 bg-white"
        >
          <option value="pr">PR & Communications</option>
          <option value="content-and-seo">Content & SEO</option>
          <option value="digital-marketing">Digital Marketing</option>
          <option value="other">Other</option>
        </select>
      </div>

      <div>
        <label className="text-sm">Message</label>
        <textarea
          rows={6}
          value={form.message}
          onChange={e=>setForm({...form, message:e.target.value})}
          className="mt-1 w-full border rounded-lg px-3 py-2 bg-white"
          placeholder="A few lines about your project, timeline, and goals."
        />
      </div>

      {submitStatus === 'success' && (
        <div className="p-4 bg-green-50 border border-green-200 rounded-lg text-green-800">
          Thanks! I'll get back to you within 24 hours.
        </div>
      )}
      
      {submitStatus === 'error' && (
        <div className="p-4 bg-red-50 border border-red-200 rounded-lg text-red-800">
          Something went wrong. Please try again or email me directly.
        </div>
      )}

      <div className="flex justify-center">
        <button 
          className="btn btn-primary disabled:opacity-50" 
          type="submit"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Sending...' : 'Send message'}
        </button>
      </div>
    </form>
  );
}